module.exports = __webpack_public_path__ + "img/whats-new-53-hero_16x9_en_poster.2e02cb3.jpg";